module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cl":{"applyButton":"Aplicar","thanksButton":"Ok, gracias","cancelButton":"Cancelar"},"pe":{"applyButton":"Aplicar","thanksButton":"Ok, gracias","cancelButton":"Cancelar"},"br":{"applyButton":"Aplicar","thanksButton":"Ok, obrigado","cancelButton":"Cancelar"}}')
  delete Component.options._Ctor
}
